import { render, staticRenderFns } from "./TheMessageItem.vue?vue&type=template&id=1b00881a&scoped=true"
import script from "./TheMessageItem.vue?vue&type=script&lang=js"
export * from "./TheMessageItem.vue?vue&type=script&lang=js"
import style0 from "./TheMessageItem.vue?vue&type=style&index=0&id=1b00881a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b00881a",
  null
  
)

export default component.exports